<template>
    <v-navigation-drawer v-model="isSidebarActive" class="dark:tw-bg-neutral-900 !tw-fixed">

        <div class=" tw-flex tw-items-center tw-justify-center tw-p-3 tw-border-b tw-bg-gray-200 tw-font-bold">
            <h1>POS MANAGER</h1>
        </div>

        <!-- Links -->
        <div class="tw-flex tw-flex-col tw-gap-2 mt-2">
            <div v-for="link in links" :key="link.id">
                
                <div class="tw-w-full" v-if="!link?.hasChildren">

                    <SidebarOrdersLink v-if="link.to == 'orders/index'"  :link="link" />

                    <SidebarLink :link="link"  v-else/>
                </div>

                <SidebarDropdownLink v-if="!!link?.hasChildren"  :link="link" />
            </div>

        </div>

    </v-navigation-drawer>
</template>

<script>
import links from '@/config/dashboard_links'

import SidebarLink from '@/layouts/dashboard/partials/sidebar/SidebarLink'
import SidebarOrdersLink from '@/layouts/dashboard/partials/sidebar/SidebarOrdersLink'
import SidebarDropdownLink from '@/layouts/dashboard/partials/sidebar/SidebarDropdownLink'

export default {
    components: { SidebarLink, SidebarOrdersLink, SidebarDropdownLink },

    data() {
        return {
            links
        }
    },

    computed: {
        isSidebarActive: {
            get() {
                return this.$store.getters['dashboard/IsSidebarActive']
            },
            set(value) {
                this.$store.dispatch('dashboard/setIsSidebarActive', value)
            }
        }
    },

    watch: {
        isSidebarActive() {
            this.drawer = this.isSidebarActive
        },
    },    

    mounted() {
        if (this.$vuetify.display.mdAndDown) {
            this.$store.dispatch('dashboard/setIsSidebarActive', false)
        }
    }
}
</script>

<style>

</style>